/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import { useRouter } from 'next/navigation';
import { JSX } from 'react';
import { Translated } from 'utils/staticText';
import { trackQuitRewards } from '../../lib/tracking';
import { ITrackingProductPageBaseParameters } from '../../lib/tracking/shared/baseParameters';
import { CatalogProductFragment } from '../types';
import { ProductHeaderStaticText } from './i18n';
import ArrowLeftAlt from '$/components/icons/ArrowLeftAlt';

type HeaderProps = {
  authEndpoint?: string;
  logo: JSX.Element;
  product: CatalogProductFragment;
  staticText: Translated<typeof ProductHeaderStaticText>;
  tracking: ITrackingProductPageBaseParameters;
};

export function ProductHeader(props: HeaderProps): JSX.Element {
  const router = useRouter();

  return (
    <header className="flex h-[--size-top-nav-1] flex-col items-center justify-center shadow-md bg-[--colors-neutral-white] md:h-[--size-top-nav-2] lg:h-[--size-top-nav-3] xl:h-[--size-top-nav-4]">
      <div className="flex h-full items-center self-stretch px-[--spacing-4]">
        <div className="mx-auto flex h-9 w-full items-center justify-between gap-2 md:h-10 md:w-[--general-narrow-content-max-width-2] md:max-w-[--general-narrow-content-max-width-2] lg:h-11 lg:w-[--breakpoints-content-narrow-3-md] lg:max-w-[--breakpoints-content-narrow-3-md] lg:gap-[--gap-6] xl:w-[--breakpoints-content-narrow-3-lg] xl:max-w-[--breakpoints-content-narrow-3-lg]">
          <button
            type="button"
            onClick={() => {
              trackQuitRewards(props.tracking);
              router.back();
            }}
          >
            <ArrowLeftAlt className="size-[--shapes-icon-size-lg]" />
          </button>
          <div className="w-25 shrink-0 grow-0 md:w-[125px] lg:w-32">
            {props.logo}
          </div>
          <div />
        </div>
      </div>
    </header>
  );
}
